export const KELAS_OPTIONS = [
  "SVIP",
  "VIP",
  "Utama",
  "I",
  "II",
  "III",
  "Isolasi",
  "NonKelas"
];

export const KODE_KELAS_SIMRS: Record<string, string> = {
  "1": "I",
  "2": "II",
  "3": "III",
  "3A": "III",
  "3B": "III",
  V: "VIP",
  U: "Utama",
  S: "SVIP",
  I: "Isolasi",
  K: "NonKelas"
};

export interface JurnalRanapRow {
  unit?: { id?: string; name?: string } | null;
  kelas?: string | null;
  no_bed?: string | null;
}

export interface RegisterRingkas {
  no?: string | number;
  unit_nama?: string | null;
  kl?: string | null;
  jurnal_ranap?: JurnalRanapRow[] | null;
}

export interface PrefillBangsalKelas {
  bangsal?: string;
  kelas?: string;
}

export function jurnalRanapTerakhir(
  reg: RegisterRingkas | null | undefined,
  register: string | number
): JurnalRanapRow | null {
  if (!reg || String(reg.no) !== String(register)) return null;

  const jurnal = reg.jurnal_ranap;
  if (!Array.isArray(jurnal) || !jurnal.length) return null;

  return jurnal[jurnal.length - 1];
}

export function normalisasiKelas(
  kelas: string | null | undefined,
  kelasOptions: string[] = KELAS_OPTIONS
): string | undefined {
  const mentah = kelas ? String(kelas).trim() : "";
  if (!mentah) return undefined;

  const dariKode = KODE_KELAS_SIMRS[mentah.toUpperCase()];
  if (dariKode && kelasOptions.indexOf(dariKode) >= 0) return dariKode;

  return kelasOptions.find(o => o.toLowerCase() === mentah.toLowerCase());
}

export function prefillBangsalKelas(
  reg: RegisterRingkas | null | undefined,
  register: string | number,
  kelasOptions: string[] = KELAS_OPTIONS
): PrefillBangsalKelas {
  const out: PrefillBangsalKelas = {};
  if (!reg || String(reg.no) !== String(register)) return out;

  const jurnal = jurnalRanapTerakhir(reg, register);

  if (jurnal) {
    const namaBangsal =
      jurnal.unit && jurnal.unit.name ? String(jurnal.unit.name).trim() : "";
    if (namaBangsal) out.bangsal = namaBangsal;

    const kelas = normalisasiKelas(jurnal.kelas, kelasOptions) || normalisasiKelas(reg.kl, kelasOptions);
    if (kelas) out.kelas = kelas;

    return out;
  }

  const namaUnit = reg.unit_nama ? String(reg.unit_nama).trim() : "";
  if (namaUnit) out.bangsal = namaUnit;

  const kelas = normalisasiKelas(reg.kl, kelasOptions);
  if (kelas) {
    out.kelas = kelas;
  } else if (kelasOptions.indexOf("NonKelas") >= 0) {
    out.kelas = "NonKelas";
  }

  return out;
}

export function prefillRuangRawat(
  reg: RegisterRingkas | null | undefined,
  register: string | number
): string {
  return prefillBangsalKelas(reg, register).bangsal || "";
}
